import React, { useState } from "react";
import "./style.scss";
import { useGetOrderDataQuery } from "../../../services/myAccountAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import Loader from "../fullPageLoader"

const Orders = () => {
  const user_id = localStorage.getItem("gridMarker"); // Get user_id from localStorage
  const [currentPage, setCurrentPage] = useState(1); // Track current page for pagination

  // Fetch order data for the current user and page
  const { data, error, isLoading } = useGetOrderDataQuery(user_id, {
    refetchOnMountOrArgChange: true, // Refetch data when the user_id changes
  });

  const {
    data: colorthemeData,
  } = useGetColorThemeQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Error loading page content</p>;

  // Extract orders and pagination data from the API response
  const orders = data?.data?.orders?.data || [];
  const pagination = data?.data?.pagination || {};

  const handlePageChange = (page) => {
    if (page > 0 && page <= pagination.last_page) {
      setCurrentPage(page);
    }
  };

  const renderPagination = () => {
    const totalPages = pagination.last_page;
    const pageNumbers = [];

    if (totalPages <= 8) {
      // Show all pages if total pages are less than or equal to 8
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show first 4 pages, ellipsis, and last 4 pages
      if (currentPage <= 4) {
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else if (currentPage >= totalPages - 3) {
        // Show first 4 pages, ellipsis, and last 4 pages
        for (let i = 1; i <= 4; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        // Show first 2 pages, ellipsis, current page and neighbors, ellipsis, and last 2 pages
        pageNumbers.push(1, 2);
        pageNumbers.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push("...");
        pageNumbers.push(totalPages - 1, totalPages);
      }
    }

    return pageNumbers;
  };

  return (
    <div className="orders">
      <div className="orders-table">
        <h2>Orders</h2>
        <table>
          <thead>
            <tr>
              <th>Order Id</th>
              <th>Order Date</th>
              <th>Status</th>
              <th>Total</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id}>
                <td>{order.order_id}</td>
                <td>{order.created_at}</td>
                <td>
                  <span
                    className={`status ${order?.order_status?.toLowerCase()}`}
                  >
                    {order.order_status === "order_placed"
                      ? "Order Placed"
                      : order.order_status === "processing"
                        ? "Processing"
                        : order.order_status === "shipped"
                          ? "Shipped"
                          : order.order_status === "delivered"
                            ? "Delivered"
                            : order.order_status === "cancelled"
                              ? "Cancelled"
                              : "Unknown Status"}
                  </span>
                </td>
                <td>{order.final_total_amount}</td>
                <td>
                  <Link to={`/orders/${order?.id}/${order?.order_id}`}>
                    <button className="view-button" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>View</button>
                  </Link>
                
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="pagination">
          {/* Previous Button with Icon */}
          <button
            onClick={() => handlePageChange(pagination.current_page - 1)}
            disabled={!pagination.prev_page_url}
            className={`page-btn arrow-btn ${!pagination.prev_page_url ? "disabled" : ""
              }`}
          >
            <FontAwesomeIcon icon={faChevronLeft} /> {/* Previous Icon */}
          </button>

          {/* Page Numbers */}
          {renderPagination().map((page, index) => (
            <button
              key={index}
              className={`page-btn ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
              disabled={page === "..." || page === currentPage}
              style={
                currentPage === page
                  ? {
                    backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                    color: "white",
                    borderColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50",
                  }
                  : {}
              }
            >
              {page === "..." ? "..." : page}
            </button>
          ))}
          {/* Next Button with Icon */}
          <button
            onClick={() => handlePageChange(pagination.current_page + 1)}
            disabled={!pagination.next_page_url}
            className={`page-btn arrow-btn ${!pagination.next_page_url ? "disabled" : ""
              }`}
          >
            <FontAwesomeIcon icon={faChevronRight} /> {/* Next Icon */}
          </button>
        </div>
        {/* ------------ */}
      </div>
    </div>
  );
};

export default Orders;
